export default function PageHeader({ eyebrow, title, description, action }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
      <div>
        {eyebrow && <div className="overline mb-2 text-[hsl(var(--sage-hover))]">{eyebrow}</div>}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-neutral-900">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-neutral-500 max-w-2xl">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
